var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-switch',{attrs:{"disabled":""},model:{value:(_vm.catalog.armisValidation),callback:function ($$v) {_vm.$set(_vm.catalog, "armisValidation", $$v)},expression:"catalog.armisValidation"}})}
var staticRenderFns = []

export { render, staticRenderFns }